import { SettingsBase } from '@/composeables/settings/SettingsBase';
import { ProductionDeviceSetting } from '@/objects/generated';

export class ProductionSettings extends SettingsBase {
    static NAME_OF_CLASS = 'ProductionSettings';
    public CurrentSetting?: string;

    public Devices?: Array<ProductionDeviceSetting>;

    constructor(productionSettings?: ProductionSettings) {
        super();
        if (!productionSettings) {
            return;
        }
        this.CurrentSetting = productionSettings.CurrentSetting;
        this.Devices = productionSettings.Devices?.map((device) => device.DeepClone());
    }

    public override serialize = (): string => {
        return (
            '{' +
            `"CurrentSetting": ${JSON.stringify(this.CurrentSetting)}` +
            ',' +
            `"Devices": [ ${this.Devices?.map((x) => (!x ? null : x?.serialize()))} ]` +
            '}'
        );
    };

    public override deserialize = (json: any): any => {
        const { CurrentSetting, Devices } = JSON.parse(json);
        const productionSettings = new ProductionSettings();
        productionSettings.CurrentSetting = CurrentSetting;
        productionSettings.Devices = Devices.map((deviceJson: any) => ProductionDeviceSetting._FromServerJson(deviceJson));
        return productionSettings;
    };

    /**
     * Return the current device setting
     * @param DeviceId
     * @returns
     */
    public GetCurrentDevice = (): ProductionDeviceSetting | undefined => {
        if (!this.Devices || !this.CurrentSetting) {
            return;
        }
        return this.Devices?.find((device) => device.DeviceId === this.CurrentSetting);
    };

    public SetCurrentDevice = (DeviceId: string): void => {
        this.CurrentSetting = DeviceId;
    };
}
